export default "/arbitrum.82f10760c20f82a4154abdd849891c44.svg";